import React, {PropsWithChildren} from 'react';
import Typography from '@material-ui/core/Typography';

import {CloseButtonRightSide} from './close-button/close-button';
import {StyledDialogContent, StyledDialogTitle} from '../modal.styled';

export const ModalContent = ({
    children, headerTitle, onClose, showCloseButton
}: PropsWithChildren<{
        showCloseButton?: boolean
        headerTitle?: string
        onClose: () => any
    }>) => {
    return (
        <>
            {typeof headerTitle === 'string' ?
                <StyledDialogTitle disableTypography>
                    <Typography variant={'h3'}>
                        {headerTitle}
                    </Typography>

                    {showCloseButton ?
                        <CloseButtonRightSide
                            data-testid={'CloseButton'}
                            onClick={onClose}
                        /> : null}
                </StyledDialogTitle> : null}

            <StyledDialogContent>
                {children}
            </StyledDialogContent>
        </>
    );
}
;
